import { createFileRoute } from '@tanstack/react-router';

import { buildRouteExport } from '~/utils/buildRouteExport';

import { CategoriesTable } from '~/components/settings/admin/articleMaster/CategoriesTable';

import { validateSearch } from './-routeParams';

export const Route = createFileRoute(
  '/(main)/settings/article-master/categories/',
)({
  component: CategoriesTable,
  validateSearch,
});

export const ARTICLE_MASTER_CATEGORIES = buildRouteExport({
  Route,
});
